import { action, thunk } from 'easy-peasy'
import {
  dependencyContextMapper,
  errorMapper,
  requestMapper,
  responseMapper,
  sendLogHitEndpoint,
} from 'lib/datadog/log'
import objectToCamelCase from 'lib/transform/object-to-camel-case'
import sellerEvent from 'services/Seller/events'
import IOrderReportModel from 'services/Seller/models/ReportModel/OrderReportModel/interface'

const OrderReportModel: IOrderReportModel = {
  isLoading: false,
  isError: false,
  data: {
    orderPercentage: 0,
    successfulOrders: 0,
    rejectedOrders: 0,
    buyerPercentage: 0,
    oldBuyers: 0,
    newBuyers: 0,
    acceptedTime: 0,
    processedTime: 0,
  },
  setIsLoading: action((state, payload) => {
    state.isLoading = payload
  }),
  setIsError: action((state, payload) => {
    state.isError = payload
  }),
  setData: action((state, payload) => {
    state.data = payload
  }),
  getOrderReport: thunk(async (actions, payload, { injections }) => {
    actions.setIsLoading(true)
    actions.setIsError(false)
    try {
      const { apiClient } = injections
      const res = await apiClient({
        url: `/seller/v2/sales-report/order?start_date=${payload.startDate}&end_date=${payload.endDate}`,
        method: 'GET',
      })
      actions.setData(objectToCamelCase(res?.data))
      sendLogHitEndpoint(
        sellerEvent.getOrderReport.event,
        dependencyContextMapper(
          sellerEvent.getOrderReport.dependency,
          requestMapper(res.config),
          responseMapper(res),
        ),
      )
    } catch (err) {
      actions.setIsError(true)
      sendLogHitEndpoint(
        sellerEvent.getOrderReport.event,
        dependencyContextMapper(
          sellerEvent.getOrderReport.dependency,
          requestMapper(err.config),
          errorMapper(err),
        ),
      )
    } finally {
      actions.setIsLoading(false)
    }
  }),
  getExportReport: thunk(async (actions, payload, { injections }) => {
    actions.setIsLoading(true)
    actions.setIsError(false)
    try {
      const { apiClient } = injections
      const response = await apiClient({
        url: `/seller/v2/sales-report/export-report?start_date=${payload.startDate}&end_date=${payload.endDate}`,
        method: 'GET',
      })
      sendLogHitEndpoint(
        sellerEvent.getExportReport.event,
        dependencyContextMapper(
          sellerEvent.getExportReport.dependency,
          requestMapper(response.config),
          responseMapper(response),
        ),
      )
      return response?.data?.download_url
    } catch (err) {
      actions.setIsError(true)
      sendLogHitEndpoint(
        sellerEvent.getExportReport.event,
        dependencyContextMapper(
          sellerEvent.getExportReport.dependency,
          requestMapper(err.config),
          errorMapper(err),
        ),
      )
      throw err
    } finally {
      actions.setIsLoading(false)
    }
  }),
}

export default OrderReportModel
